import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText
} from '@mui/material'
import { useCallback } from 'react'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { MultipleChoiceAnswerWithRelated } from '../../models/inspections'
import { useUpdateAnswerToCannedJobMutation } from '../../redux/api/inspectionApi'
import { InspectionAnswerToCannedJobEntry } from '../../sdk'
import { sortAnswerToCannedJobExpandedByName } from '../../utils/sortCannedJobByName'

export const AnswerToActionSelection = ({
  answer
}: {
  answer: MultipleChoiceAnswerWithRelated
}) => {
  const { accessToken } = useAccessTokenAndShopId()
  const [update] = useUpdateAnswerToCannedJobMutation()
  const handleChange = useCallback(
    (checked: boolean, entry: InspectionAnswerToCannedJobEntry) => {
      update({
        authorization: accessToken,
        inspectionAnswerToCannedJobEntry: {
          ...entry,
          info: {
            ...entry.info!,
            selected: checked
          }
        }
      })
    },
    [accessToken, update]
  )
  if (answer.answerToCannedJobs.length === 0) {
    return <></>
  }
  return (
    <>
      <FormControl component="fieldset" variant="standard">
        {!answer.answerToCannedJobs.some((a) => a.info!.selected) && (
          <FormHelperText error>
            * Please select canned jobs to recommend
          </FormHelperText>
        )}
        <FormGroup>
          {sortAnswerToCannedJobExpandedByName(answer.answerToCannedJobs).map(
            (a) => (
              <FormControlLabel
                key={a.id!}
                control={
                  <Checkbox
                    checked={!!a.info!.selected}
                    onChange={(event) => handleChange(event.target.checked, a)}
                    name={a.id!}
                  />
                }
                label={a.cannedJobExpanded?.entry!.info!.name}
              />
            )
          )}
        </FormGroup>
      </FormControl>
    </>
  )
}
